<template>
  <van-dialog style="border-radius:10px" v-model="popshow" :show-confirm-button="false" :show-cancel-button="false">
    <div class="refund_box">
      <div>
        <div class="refund_flex">
          <van-icon name="smile" color="#FF9D3E" size="28" />
          <span class="refund_onspan">温馨提示</span>
        </div>
      </div>
      <div class="refund_text">您提交的{{ chanrund==2 ? '改签':"退票" }}原因:</div>
      <div class="refund_onspan" style="margin-left: 0px">{{ refundResaon }}</div>
      <div class="refund_text" v-if="!isShowNoRefundReason">
        预估{{ chanrund==2 ? '改签':"退票" }}手续费:
        <span
          style="color:#FF9D3E">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;￥{{
          total }}</span>
      </div>
      <div class="refund_text">提示:&nbsp;&nbsp;
        <span style="color:#FF9D3E;font-size: 13px;">申请提交后不可撤销,将尽快为您取消机位,处理{{ chanrund==2 ? '改签':"退票" }}</span>
      </div>
      <div/>
    </div>
    <!-- <div class="refund_button">
    <van-button  class="custom-button" color="#11A265" size="small" @click="$emit('cancel')">&nbsp;取消&nbsp;</van-button>
    <van-button color="#FF9D3E" size="small" @click="continueSubmit()">继续提交</van-button>
    </div> -->
    <div class="text-right" style="margin: 10px;">
      <van-button size="normal" @click="$emit('cancel')" style="height:36px" type="primary">
        {{ $t('B008', '取消') }}
      </van-button>
      &nbsp;
      <van-button style="height:36px" size="normal" type="info" @click="continueSubmit()">
        {{ $t('B006', '确定') }}
      </van-button>
    </div>
  </van-dialog>
</template>

<script>
import { Dialog,Button} from 'vant'
export default {
  name: 'Refunddialog',
  props: {
    popshow: {
      type: Boolean,
      default: false
    },
    refundResaon: '',  //退票原因
    isShowNoRefundReason: false,  //自愿还是非自愿
    total: {
      type: [Number, String]
    },
    chanrund: ""
  },
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
  },

  methods:{
    continueSubmit(){
      this.$emit('continueSubmit')
    }
  }

}
</script>

<style lang="less" scoped>
.refund_box{
	padding: 10px 10px 10px 10px
}
.refund_onspan{
  font-size: 13px;
  color: #85868E;
  display: inline-block;
  margin-left: 10px;
  margin-top: 6px;
  font-weight: 600;
}
.refund_flex{
	display: flex;
	align-items: flex-start;
}

.refund_text {
  // font-weight: bold;
  font-size: 13px;
  color: #181818;
  text-rendering: optimizeLegibility;
  margin-top: 10px;
  font-weight: 600;
}
.refund_colel{
  color: #FF9D3E;
}

.refund_button {
  float: right;
  display: flex;
  width: 64%;
  justify-content: space-around;
  margin-bottom: 10px;
}

.van-dialog {
  border-radius: 0px;
}

.custom-button {
  width: 30%; /* 或是其他您想要的宽度，比如 100px */
}
</style>
